import { Api } from '@axiom/ui';
import type { DSSuggestedIntake } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class IntakeSuggestApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async createIntakeSuggestion(intakePrompt: string) {
    return super.write<{ data: DSSuggestedIntake }>({
      endpoint: '/intake/details/suggest',
      method: 'POST',
      body: { intakePrompt },
    });
  }
}

export const IntakeSuggestApi = new IntakeSuggestApiClass();
